import {
    AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild
} from '@angular/core';
import { environment } from 'environments/environment';
import {ApiClientService} from '../../services/api-client.service';

declare const $: any;
declare const toastr: any;
declare const Stripe: any;

@Component({
    selector: 'stripe-payment',
    templateUrl: 'stripe-payment.component.html',
    styleUrls: ['stripe-payment.component.scss']
})

export class StripePaymentComponent implements AfterViewInit, OnDestroy {
    stripe: any;
    card: any;
    cardHandler = this.onChange.bind(this);
    error: string;
    @ViewChild('cardInfo') cardInfo: ElementRef;
    @Output() setter: EventEmitter<any> = new EventEmitter<any>();
    @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();
    @Output() onFailure: EventEmitter<any> = new EventEmitter<any>();
    buttonDisabled = false;

    constructor(private cd: ChangeDetectorRef,
                public api: ApiClientService) {}

    ngAfterViewInit() {
        this.stripe = Stripe(environment.stripeKey);
        const elements = this.stripe.elements();
        this.card = elements.create('card');
        this.card.mount(this.cardInfo.nativeElement);

        this.card.addEventListener('change', this.cardHandler);
    }

    ngOnDestroy() {
        this.card.removeEventListener('change', this.cardHandler);
        this.card.destroy();
    }

    onChange({ error }) {
        if (error) {
            this.error = error.message;
        } else {
            this.error = null;
        }
        this.cd.detectChanges();
        this.setter.emit(null);
    }

    async applyCard() {
        this.buttonDisabled = true;
        const { token, error } = await this.stripe.createToken(this.card);
        if(error) {
            if(this.card._empty) {
                error.code = 'empty';
                error.message = 'Card Number is empty';
            } else
                this.api.errorHandler(error, error.message);
            this.onFailure.emit(error);
        } else if(token) {
            toastr.success('Credit Card information has been confirmed and will be used for this booking.');
            this.setter.emit(token.id);
            this.onSuccess.emit();
        }
        this.buttonDisabled = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/stripe-payment/stripe-payment.component.ts